import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { AudienceSection } from '../components/sections/AudienceSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { CredibilitySection } from '../components/sections/CredibilitySection';
import { PricingSection } from '../components/sections/PricingSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { TestimonialSection } from '../components/sections/TestimonialSection';
import { FAQSection } from '../components/sections/FAQSection';
import { FooterSection } from '../components/sections/FooterSection';
export function LandingPage() {
  return <main className="min-h-screen bg-background text-gray-300 font-body selection:bg-primary/30 selection:text-white" data-id="element-287">
      <HeroSection data-id="element-288" />
      <SolutionSection data-id="element-289" />
      <ProblemSection data-id="element-290" />
      <AudienceSection data-id="element-291" />
      <BenefitsSection data-id="element-292" />
      <CredibilitySection data-id="element-293" />
      <PricingSection data-id="element-294" />
      <HowItWorksSection data-id="element-295" />
      <TestimonialSection data-id="element-296" />
      <FAQSection data-id="element-297" />
      <FooterSection data-id="element-298" />
    </main>;
}